/* eslint-disable jsx-a11y/click-events-have-key-events */
import { classnames } from 'Utils/classnames/classnames.utils';
import type { ReactNode } from 'react';
import React, { useEffect, useState } from 'react';
import { Icon } from 'Components/frameworks/icon/Icon';
import { TemplateString } from 'Components/frameworks/template-string/TemplateString';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
type Props = {
  children: Array<Node>;
};
const HEIGHT = 110;
export const Pancakes = ({ children }: Props) => {
  const [shouldAppear, setShouldAppear] = useState(false);
  const [isSpread, setIsSpread] = useState(false);
  const [toasterItems, setToasterItems] = useState(
    children.map((child, key) => {
      return {
        child,
        shouldDisplay: false,
        key,
        isClosed: false,
      };
    }),
  );
  const hasOnlyEverHadOneToaster =
    toasterItems.filter(({ isClosed, shouldDisplay }) => !isClosed && shouldDisplay).length === 1;
  useEffect(() => {
    const timeoutID = setTimeout(() => {
      setShouldAppear(true);
    }, 300);
    return () => {
      clearTimeout(timeoutID);
    };
  }, []);
  const filteredItems = toasterItems.filter((item) => item.shouldDisplay && !item.isClosed);
  const shouldDisplayAsSpread = isSpread && filteredItems.length > 1;
  let index = 0;

  const generateChild = ({ child, key }) =>
    React.cloneElement(child, {
      setIsVisible: (isVisible) => {
        setToasterItems((prevItems) => {
          return prevItems.map((item) => {
            if (item.key === key) {
              return { ...item, shouldDisplay: isVisible };
            }

            return item;
          });
        });
      },
      onClose: () => {
        setToasterItems((prevItems) => {
          return prevItems.map((item) => {
            if (item.key === key) {
              return { ...item, shouldDisplay: false, isClosed: true };
            }

            return item;
          });
        });
      },
      isSpread: shouldDisplayAsSpread || filteredItems.length === 1,
    });

  return shouldAppear ? (
    <div
      className={classnames(
        'animation-duration-500 mt-navigation absolute inset-x-0 z-4 mx-10 me-10 max-w-full pt-10 sm:end-0 sm:start-auto sm:w-full md:max-w-400 lg:me-30 lg:pt-30 ltr:animate-slideInRight rtl:animate-slideInLeft',
      )}
      style={{
        perspective: 1000,
        perspectiveOrigin: 'bottom',
      }}
    >
      {filteredItems.length > 1 && (
        <button
          onClick={() => {
            setIsSpread(!isSpread);
          }}
          className="transition-transform absolute end-0 h-30 cursor-pointer rounded-4 bg-white px-10 text-14 font-bold text-black shadow duration-250 ease-in"
          style={{
            transform: `translateY(${shouldDisplayAsSpread ? 0 : '2.5rem'})`,
          }}
          type="button"
        >
          {t('common.loadLess')}
          <Icon name={ICONS.ARROW_DOWN} width="0.625rem" className="ms-10" />
        </button>
      )}
      {toasterItems
        .filter((item) => !item.isClosed)
        .map(({ child, key, shouldDisplay }) => {
          const shouldActAsButton = index === 0 && !isSpread; // using native buttons breaks stuff

          const content = generateChild({
            child,
            key,
            shouldDisplay,
          });
          return (
            <div
              className={classnames(
                'transition-transform absolute mb-10 w-full rounded-12 bg-white p-10 shadow duration-250 ease-in',
                {
                  'cursor-pointer': shouldActAsButton,
                },
                {
                  hidden: !shouldDisplay,
                },
              )}
              style={{
                zIndex: children.length - index,
                transform: shouldDisplayAsSpread
                  ? `translateY(${(HEIGHT + 10) * index + 40}px`
                  : `translateY(${10 * index}px) translateZ(${-30 * index}px)`,
                height: hasOnlyEverHadOneToaster ? 'auto' : `calc(${HEIGHT}rem / 16)`,
                willChange: 'transform',
              }}
              tabIndex={shouldActAsButton ? index : -1}
              role={shouldActAsButton ? 'button' : 'presentation'}
              onClick={shouldActAsButton ? () => setIsSpread(true) : () => {}}
              key={key}
            >
              {content}
              {shouldDisplay && index++ === 0 && filteredItems.length > 1 && (
                <span
                  className={classnames(
                    'absolute bottom-[10px] text-12 text-mediumGrey transition-opacity duration-250 ease-in',
                    {
                      'opacity-0': isSpread,
                    },
                  )}
                >
                  <TemplateString
                    template={t('common.moreNotifications')}
                    values={{
                      number: filteredItems.length - 1,
                    }}
                  />
                </span>
              )}
            </div>
          );
        })}
    </div>
  ) : null;
};
